import { omit, pick } from "lodash";
import { forwardRef, useMemo } from "react";
import { WIDTH_BREAKPOINTS } from "e3-common/constants/common";
import FormSection, { createBtnArea } from "./FormSection";
import styles from "./FormSection.module.css";
import pageStyles from "./PageContent.module.css";
import E3ModalPopup from "../ModalPopup/E3ModalPopup";

const FormModalPopup = forwardRef((props, ref) => {
  const {
    title,
    width = WIDTH_BREAKPOINTS.md,
    height = "400px",
    bottomBtn,
    formProps,
    closeBtnEvent = () => {},
    ...rest
  } = props || {};

  const { formControls = {} } = formProps || {};

  const formSectionProps = {
    ...pick(formProps, ["numOfCols", "checkAuth"]),
    formControls,
  };

  const btnAreaProps = {
    ...pick(formProps, ["btnNodes", "btnInit", "btnAdd", "btnSave", "btnDel", "additionalBtns", "checkAuth"]),
    className: styles.modalBtnWrapper,
  };

  const leftButtons = useMemo(() => createBtnArea(btnAreaProps), [btnAreaProps]);

  return (
    <E3ModalPopup
      ref={ref}
      defaultTitle={title}
      defaultHeight={height}
      defaultWidth={WIDTH_BREAKPOINTS[width] || width}
      leftButtons={!bottomBtn ? leftButtons : null}
      closeBtnEvent={closeBtnEvent}
      {...omit(rest, ["checkAuth"])}
    >
      {bottomBtn && (
        <div className={pageStyles.borderDiv}>
          <div className="left_right_wrap">
            <div className="con_left_wrap">
              <div className={pageStyles.divTitle_lv1}>{title}</div>
            </div>
            <div className="con_right_wrap">{leftButtons}</div>
          </div>
        </div>
      )}
      <FormSection {...formSectionProps} />
    </E3ModalPopup>
  );
});

export default FormModalPopup;
